export default "/_next/static/chunks/fonts/Montserrat Regular-1506488cb96406ff6ba82d17c3dcd60a.otf";